import { Chip } from "@mui/material";
import Typography, { TypographyProps } from "@mui/material/Typography";
import styled from "styled-components";

export const ToolbarContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ToolbarButtons = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.25)};
`;

export const TableCaption = styled(Typography)`
  margin: ${({ theme }) => theme.spacing(1, 1, -1.25)};
  color: ${({ theme }) => theme.palette.text.secondary};
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  font-size: smaller;
  /* font-size: 0.8rem; */
`;

export const TableSpacer = styled.div`
  height: ${({ theme }) => theme.spacing(4)};
`;

/* the page header, built like the one on the virtual machine details page */
export const SummaryContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SummaryColumn = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const Title = styled(Typography)<
  TypographyProps<"h2", { component: "h2" }>
>`
  margin-right: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const DetailsTitle = styled.span`
  color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.primary.main
      : theme.palette.text.secondary};
  font-weight: 500;
  font-size: 0.9rem;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const DetailsInfo = styled.span`
  margin-right: ${({ theme }) => theme.spacing(2)};
  font-size: 0.9rem;
`;

export const DetailsInfoColored = styled(DetailsInfo)`
  color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.text.primary
      : theme.palette.primary.main};
  font-weight: 450;
  font-size: 0.9rem;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const Tag = styled(Chip)`
  margin-right: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.grey[900]
      : theme.palette.grey[100]};

  & .MuiChip-deleteIcon {
    font-size: 16px;
    margin-left: ${({ theme }) => theme.spacing(0.5)};
    color: ${({ theme }) => theme.palette.primary.main};

    &:hover {
      color: ${({ theme }) => theme.palette.primary.dark};
    }
  }
`;

// a bucket policy example in the page tour
export const PolicyCode = styled.pre`
  margin: ${({ theme }) => theme.spacing(1.5, 0, 0)};
  padding: ${({ theme }) => theme.spacing(1.5)};
  overflow-x: auto;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 4px;
  background: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.grey[900]
      : theme.palette.grey[100]};
  color: ${({ theme }) => theme.palette.text.primary};
  font-family:
    ui-monospace, "SFMono-Regular", "Menlo", "Consolas", "Liberation Mono",
    monospace;
  font-size: 0.75rem;
  line-height: 1.5;
  white-space: pre;
`;
